import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-si-glyph-arrow-thin-left-bottom",
  "use": "icon-si-glyph-arrow-thin-left-bottom-usage",
  "viewBox": "0 0 17 16",
  "content": "<symbol viewBox=\"0 0 17 16\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" class=\"si-glyph si-glyph-arrow-thin-left-bottom\" id=\"icon-si-glyph-arrow-thin-left-bottom\">\n    <!-- Generator: Sketch 3.0.3 (7891) - http://www.bohemiancoding.com/sketch -->\n    <title>1175</title>\n    \n    <defs></defs>\n    <g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <path d=\"M1.124,15.922 L1.107,7.201 C1.107,6.553 1.718,6.172 2.002,6.174 C2.572,6.175 2.95,6.638 2.951,7.208 L2.961,12.555 L15.355,0.355 C15.717,-0.00599999997 16.311,0.00100000003 16.682,0.373 C17.055,0.744 17.063,1.339 16.7,1.7 L4.554,14.012 L9.887,14.02 C10.457,14.022 10.92,14.485 10.92,15.053 C10.923,15.623 10.463,15.94 9.893,15.938 L1.124,15.922 L1.124,15.922 Z\" fill=\"#434343\" class=\"si-glyph-fill\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/glyph/si-glyph-arrow-thin-left-bottom.svg
// module id = KXtK
// module chunks = 62